import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import App from './App.vue'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import { store } from './store'
import router from './router'
// import * as firebase from 'firebase'


import firebase from '@/helpers/firebaseConfig'
import AlertCmp from './components/shared/Alert.vue'
import './registerServiceWorker'

export const bus = new Vue()

Vue.use(VueAxios, axios)
Vue.config.productionTip = false

Vue.component('app-alert', AlertCmp)

Vue.filter('capitalize', function (value) {
  if (!value) return ''
    value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('uppercase', function (value) {
  if (!value) return ''
    value = value.toString()
  return value.toUpperCase()
})

new Vue({
  el: '#app',
  vuetify,
  firebase,
  router,
  store,
  render: h => h(App),
  created () {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
        // router.push('/options')
      }
      else {
        router.push('/')
      }
    })
  }
})
